'use client'

import { HTMLAttributes } from 'react'
import styled from 'styled-components'

import {
  ViewportSizes,
  timingSlowerMs,
  useIsViewport,
  useScrollDirection,
} from '@syconium/little-miss-figgy'

const NavToolbarElement = styled.div<{ $visible?: boolean }>`
  background-color: ${o => o.theme.color.fill.background};
  position: sticky;
  z-index: ${o => o.theme.zIndex.sticky};
  transition: top ${timingSlowerMs}ms ease;
  top: ${o => (o.$visible ? '0px' : '-50%')};
`

type NavToolbarProps = HTMLAttributes<HTMLDivElement> & {
  /** Whether or not the toolbar is actively visible. If not provided, the toolbar will automatically toggle it's visibility when the user scrolls down on mobile viewports. */
  visible?: boolean
}

/** Generic sticky toolbar component that can be within navbar components. */
export function NavToolbar({ visible, ...rest }: NavToolbarProps) {
  const isMobileViewport = useIsViewport([ViewportSizes.small], { ssr: true })
  const scrollDirection = useScrollDirection()

  return (
    <NavToolbarElement
      $visible={visible ?? (!isMobileViewport || scrollDirection !== 'down')}
      {...rest}
    />
  )
}
